import { ORG_ROLE_CREATOR } from './organizationRoles';

export const SETTINGS_POPULATED = 'settingsPopulated';
export const PRIVATE_CONTENT_DEFAULT = 'privateContentDefault';
export const CREATORS_TOP_INVITE_ROLE = 'creatorsTopInviteRole';
export const WORKSPACE_DOMAIN_JOIN_INFO = 'workspaceDomainJoinInfo';
export const WORKSPACE_PERSONA = 'workspacePersona';
export const SCIM = 'scim';
export const SCIM_TOS = 'scimToS';
export const CUSTOM_ROLE_UPGRADE_MESSAGE = 'customRoleUpgradeMessage';
export const BILLING_EMAIL_NOTIFS = 'billingEmailNotifications';
export const DATA_RETENTION = 'dataRetention';
export const SLACK_CONTACT_SYNC = 'slackContactSync';
export const GOOGLE_CONTACT_SYNC = 'googleContactSync';
export const CONTENT_PRIVACY_RESTRICTIONS = 'contentPrivacyRestrictions';
export const PRIVATE_VIDEO_PREVIEW = 'showVideoPreview';
export const WORKOS = 'workos';
// Deprecated -- do not use
export const HAS_CREATOR_LITE = 'hasCreatorLite';

// Type is required else it will default to string
// Accepted types: Boolean, Number, String, JSON

export const settingOptions = {
  [SETTINGS_POPULATED]: {
    defaultValue: false,
    type: Boolean,
  },
  [PRIVATE_CONTENT_DEFAULT]: {
    defaultValue: false,
    type: Boolean,
  },
  [CREATORS_TOP_INVITE_ROLE]: {
    defaultValue: ORG_ROLE_CREATOR,
    type: String,
  },
  // map of domain to domain options, defaults per domain:
  // domain: { domain: domain, defaultJoinRole: viewer, autoJoin: false }
  [WORKSPACE_DOMAIN_JOIN_INFO]: {
    type: JSON,
  },
  [WORKSPACE_PERSONA]: {
    defaultValue: null,
    type: JSON,
  },
  [SCIM]: {
    defaultValue: false,
    type: Boolean,
  },
  [SCIM_TOS]: {
    defaultValue: true,
    type: Boolean,
  },
  [CUSTOM_ROLE_UPGRADE_MESSAGE]: {
    defaultValue: '',
    type: String,
  },
  [BILLING_EMAIL_NOTIFS]: {
    defaultValue: true,
    type: Boolean,
  },
  [DATA_RETENTION]: {
    defaultValue: null,
    type: JSON,
  },
  [SLACK_CONTACT_SYNC]: {
    defaultValue: null,
    type: JSON,
  },
  [GOOGLE_CONTACT_SYNC]: {
    defaultValue: null,
    type: JSON,
  },
  [CONTENT_PRIVACY_RESTRICTIONS]: {
    defaultValue: null,
    type: JSON,
  },
  [PRIVATE_VIDEO_PREVIEW]: {
    defaultValue: false,
    type: Boolean,
  },
  [WORKOS]: {
    defaultValue: null,
    type: JSON,
  },
  // Deprecated -- do not use
  [HAS_CREATOR_LITE]: {
    defaultValue: true,
    type: Boolean,
  },
};
